import {
  type SourceMappingBuildContext,
  type SourceMappingOptionGroup,
  type MappingOption,
} from '../types'

export const buildBillDefaultOptions = (
  context: SourceMappingBuildContext
): SourceMappingOptionGroup => {
  const { translatedLabels, featureFlags } = context

  const options: MappingOption[] = [
    {
      label: translatedLabels.singularPrimaryOrgCategoryLabel,
      value: 'location',
      type: 'native',
      active: true,
    },
    {
      label: translatedLabels.singularSecondaryOrgCategoryLabel,
      value: 'department',
      type: 'native',
      active: true,
    },
    {
      label: translatedLabels.billUrlLabel,
      value: 'bill_url',
      type: 'native',
      active: true,
    },
  ]

  if (featureFlags?.PLAT_3573_IMPROVE_INTEGRATION_FIELD_MAPPING) {
    options.push(
      {
        label: translatedLabels.poNumberLabel,
        value: 'purchase_order.number',
        type: 'native',
        active: true,
      },
      {
        label: translatedLabels.billNotesLabel,
        value: 'bill_notes',
        type: 'native',
        active: true,
      }
    )
  }

  return {
    options,
  }
}
